<template>
  <div>
    <v-app-bar flat color="transparent" class="main-appbar">
      <app-bar-nav-icon />
      <v-toolbar-title class="headline font-weight-bold"
        >Help Centre</v-toolbar-title
      >
      <v-spacer></v-spacer>
      <v-btn icon>
        <img src="@/assets/icons/search.svg" alt height="17.7px" />
      </v-btn>
    </v-app-bar>
    <div
      class="mt-12 mx-4"
      id="user-list"
      v-infinite-scroll="loadMore"
      :infinite-scroll-disabled="loading"
      infinite-scroll-distance="100"
    >
      <v-simple-table>
        <thead>
          <tr>
            <th width="20%" colspan="2" class="text-left pa-0">
              Reporter Name
            </th>
            <th width="20%" class="text-left">Subject</th>
            <th width="20%" class="text-left">Description</th>
            <th width="20%" class="text-left">Added date</th>
            <th width="20%" class="text-left">Action</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="report in reports" :key="report.id">
            <td colspan="2">
              <span v-if="report.reporter.full_name">{{
                report.reporter.full_name
              }}</span>
              <span v-else
                >{{ report.reporter.first_name }}
                {{ report.reporter.last_name }}</span
              >
            </td>
            <td>{{ report.subject }}</td>
            <td>{{ report.description }}</td>
            <td>{{ report.addedDate }}</td>
            <td>
              <v-btn class="info" @click="viewDetails(report)">view</v-btn>
            </td>
          </tr>

          <template v-if="loading">
            <tr v-for="index in 10" :key="index + '-skeleton'">
              <td class="pl-0">
                <v-skeleton-loader
                  type="list-item"
                  transition="fade-transition"
                />
              </td>
              <td class="pl-0">
                <v-skeleton-loader
                  type="list-item"
                  transition="fade-transition"
                />
              </td>
              <td class="pl-0">
                <v-skeleton-loader
                  type="list-item"
                  transition="fade-transition"
                />
              </td>
              <td class="pl-0">
                <v-skeleton-loader
                  type="list-item"
                  transition="fade-transition"
                />
              </td>
              <td class="pl-0">
                <v-skeleton-loader
                  type="list-item"
                  transition="fade-transition"
                />
              </td>
            </tr>
          </template>
        </tbody>
      </v-simple-table>

      <div
        class="d-flex justify-center mt-3"
        v-if="!(reports.length > 0) && !loading"
      >
        <p>No match found.</p>
      </div>
    </div>

    <v-dialog v-model="dialog" width="800" class="pt-5">
      <ReportDetailsCard :report="selectedReport" />
    </v-dialog>
  </div>
</template>
<script>
import { mapState, mapActions, mapMutations } from 'vuex'
import infiniteScroll from 'vue-infinite-scroll'
import AppBarNavIcon from '@/layouts/shared/AppBarNavIcon'
import ReportDetailsCard from '../Reports/Reporter/ReportDetailsCard.vue'
export default {
  directives: {
    infiniteScroll
  },
  components: {
    AppBarNavIcon,
    ReportDetailsCard
  },
  data: () => ({
    loading: false,
    showSearch: false,
    loadMoreIndicator: false,
    filter: {
      search: ''
    },
    dialog: false,
    selectedReport: {}
  }),
  methods: {
    ...mapActions({
      getHelpCenter: 'helpCenter/getHelpCenter'
    }),
    ...mapMutations({
      clearHelpCenterList: 'helpCenter/clearHelpCenterList'
    }),
    async fetchHelpCenter(page = 1) {
      let params = { page }
      if (this.filter.search) {
        params.search = this.filter.search
      }
      this.loading = true
      await this.getHelpCenter(params)
      this.loading = false
    },

    async loadMore() {
      if (this.listMeta.current_page < this.listMeta.last_page) {
        try {
          this.loadMoreIndicator = true
          await this.fetchHelpCenter(this.listMeta.current_page + 1)
        } finally {
          this.loadMoreIndicator = false
        }
      }
    },
    viewDetails(report) {
      this.selectedReport = report
      this.dialog = true
    }
  },
  created() {
    this.clearHelpCenterList()
    this.fetchHelpCenter(1)
  },
  computed: {
    ...mapState({
      reports: state => state.helpCenter.list,
      listMeta: state => state.helpCenter.listMeta
    }),

    paginationLength() {
      return (this.listMeta.total / this.listMeta.per_page) | 0
    }
  }
}
</script>
